export default __webpack_public_path__ + "static/media/timdecotta.70270084.jpg";